import { Form, Row, Col, Select, Input, Button } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SimpleNumericInput } from 'components';
import { ReactComponent as IconUbicacion } from 'assets/images/monitoreos/SIMAC_Icono_ubicacion_mapa.svg';
import {
  selectTipoHallazgoByIdMonitoreo,
  selectCatalogByName
} from 'selectors/catalogos.selectors';
import { useJsApiLoader, GoogleMap, Marker } from '@react-google-maps/api';
import { MONITOREOS_ESPECTACULARES } from 'constants/tipoMonitoreos';
import { ATRIBUTOS, ESTADOS } from 'constants/nombresCatalogos';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { handleGeocode } from '../../../../services/geocercas.services';

const Ubicacion = ({ form, idTipoHallazgo, latitud, longitud }) => {
  const entidades = useSelector(selectCatalogByName(ESTADOS));
  const tipoHallazgos = useSelector(selectTipoHallazgoByIdMonitoreo(MONITOREOS_ESPECTACULARES));
  const atributosHallazgos = useSelector(selectCatalogByName(ATRIBUTOS));

  const findAtributoByName = (nombreAtributo) => {
    const idAtributo = atributosHallazgos.find(
      (atributo) => atributo.atributo === nombreAtributo
    )?.idAtributo;
    return idAtributo.toString();
  };

  // Start - Variables a utilizar para el mapa de google
  const [searchValueMapa, setSearchValueMapa] = useState('asda');

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
  });

  const containerStyle = {
    width: '100%',
    height: '400px'
  };
  const [center, setCenter] = useState({
    lat: parseFloat(23.416371615752457),
    lng: parseFloat(-102.31726197109397)
  });
  const [rener] = useState(false);
  const [zoomMap, setZoomMap] = useState(0);
  const [listacordenadas, setListacordenadas] = useState([]);

  const construirMapa = () => {
    try {
      const latTemp = latitud;
      const lngTemp = longitud;
      if (latTemp !== undefined && lngTemp !== undefined && latTemp !== null && lngTemp !== null) {
        if (latTemp !== '000000000' && lngTemp !== '000000000') {
          const number1 = parseFloat(latTemp);
          const number2 = parseFloat(lngTemp);
          const cordenadas = {
            lat: number1,
            lng: number2
          };
          const listaCoordenadasTmp = [cordenadas];
          setCenter(cordenadas);
          setZoomMap(17);
          setListacordenadas(listaCoordenadasTmp);
        } else {
          const cordenadas = {
            lat: parseFloat(23.416371615752457),
            lng: parseFloat(-102.31726197109397)
          };
          setCenter(cordenadas);
          setZoomMap(4);
        }
      } else {
        const cordenadas = {
          lat: parseFloat(23.416371615752457),
          lng: parseFloat(-102.31726197109397)
        };
        setCenter(cordenadas);
        setZoomMap(5);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // END - Variables a utilizar para el mapa de google

  // START - Inicio de los métodos a utilizar para el mapa de google
  const renderMapa = () => {
    if (searchValueMapa === 'asda') {
      setSearchValueMapa('');
    } else {
      setSearchValueMapa('asda');
    }
  };

  // START - Inicio de los métodos a utilizar para el mapa de google
  const onLoadMap = (mapa) => {
    // construirMapa();
    console.log(mapa);
    // renderMapa();
  };

  const onclickMap = async (mapa) => {
    // Variables del método
    // const idMunicipioTmp = 0;
    // const municipioTmp = '';
    let calleTmp = '';
    let numeroExteriorTmp = 0;
    let coloniaTmp = '';
    let codigoPostalTmp = '';
    // Obtenemos las coordenadas resultantes del método clic
    const latitudTmp = parseFloat(mapa.latLng.lat());
    const longitudTmp = parseFloat(mapa.latLng.lng());
    const cordenadas = {
      lat: latitudTmp,
      lng: longitudTmp
    };
    // Realizamos la busqueda de datos geográficos con las coordenadas
    const parametros = `${latitudTmp},${longitudTmp}`;
    // const parametrosEncode =0 encodeURIComponent(parametros);
    // const data = await ubicacionService.respuestaGogleLocation(parametrosEncode);
    const data = await handleGeocode(parametros);
    // if (data.data.status === 'OK') {
    if (data !== null) {
      // const resultados = data.data.results[0].address_components;
      const resultados = data[0].address_components;
      resultados.forEach((elem) => {
        console.log('elemento', elem);
        const campoMaps = elem.types[0];
        if (campoMaps === 'street_number') {
          numeroExteriorTmp = elem.long_name;
        }
        if (campoMaps === 'route') {
          calleTmp = elem.long_name;
        }
        if (campoMaps === 'locality') {
          coloniaTmp = elem.long_name;
        }
        if (campoMaps === 'postal_code') {
          codigoPostalTmp = elem.long_name;
        }
      });
      // eslint-disable-next-line react/no-unstable-nested-components
      form.setFieldsValue({
        calle: calleTmp,
        numeroExterior: numeroExteriorTmp,
        colonia: coloniaTmp,
        codigoPostal: codigoPostalTmp,
        longitud: longitudTmp,
        latitud: latitudTmp
      });
    } else {
      let mensajeError = '';
      if (data.data.status === 'ZERO_RESULTS') {
        mensajeError = 'No hubo resultados para la dirección ingresada.';
      } else if (
        data.data.status === 'OVER_QUERY_LIMIT' ||
        data.data.status === 'REQUEST_DENIED' ||
        data.data.status === 'UNKNOWN_ERROR'
      ) {
        mensajeError = 'Error general del mapa.';
      } else if (data.data.status === 'INVALID_REQUEST') {
        mensajeError = 'Error de la web. Contacte con Name Agency.';
      }
      // eslint-disable-next-line
      alert(mensajeError);
    }
    const listaCoordenadasTmp = [cordenadas];
    setCenter(cordenadas);
    setZoomMap(17);
    setListacordenadas(listaCoordenadasTmp);
    renderMapa();
    // END - Variables a utilizar para el mapa de google
  };

  function Market(event) {
    const lat = parseFloat(event.latLng.lat());
    const lng = parseFloat(event.latLng.lng());
    const location = {
      lat,
      lng
    };
    console.log(location);
  }

  const getLocations = () => {
    if (listacordenadas !== null) {
      const low = listacordenadas.map((y) => {
        const cordenadas = {
          lat: parseFloat(y.lat),
          lng: parseFloat(y.lng)
        };
        return (
          <Marker
            onClick={(e) => Market(e)}
            position={cordenadas}
            title={`${'Latitud:'}${y.lat}${'\n'}${'Longitud'}${y.lng}${'\n'}`}
            label="Ubicación de la visita"
          />
        );
      });
      return low;
    }
    return null;
  };

  useEffect(() => {
    // se invocan a los métodos de construcción del mapa
    construirMapa();
    renderMapa();
    form.setFieldsValue({ hallazgo: idTipoHallazgo });
  }, []);

  // eslint-disable-next-line react/no-unstable-nested-components
  const setMapUbicacion = () => {
    return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        onLoad={onLoadMap}
        onClick={onclickMap}
        streetViewControl={rener}
        zoom={zoomMap}
        mapTypeControl={false}>
        {getLocations()}
        {/* Child components, such as markers, info windows, etc. */}
      </GoogleMap>
    ) : (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <></>
    );
  };
  // END - Fin de los métodos a utilizar para el mapa de google

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row>
          <Col span={3}>
            <Form.Item
              name="entidad"
              label="Entidad:"
              rules={[{ required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }]}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => {
              return prevValues.hallazgo !== curValues.hallazgo;
            }}>
            {() => {
              const listaAtributos =
                tipoHallazgos
                  .find(
                    (tipo) =>
                      tipo.idHallazgo ===
                      (form.getFieldsValue()?.hallazgo
                        ? form.getFieldsValue()?.hallazgo
                        : idTipoHallazgo)
                  )
                  ?.atributos?.split(',') || [];

              const atributosInputs = [];
              if (listaAtributos.includes(findAtributoByName('idMunicipio'))) {
                atributosInputs.push(
                  <>
                    <Col span={1} />
                    <Col span={4}>
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevProps, newProps) => {
                          return prevProps.entidad !== newProps.entidad;
                        }}>
                        {() => {
                          const { entidad } = form.getFieldsValue(['entidad']);
                          const municipiosB =
                            entidades.find((e) => e.nombreEstado === entidad)?.municipios || [];
                          return (
                            <Form.Item
                              name="municipio"
                              label="Municipio o Alcaldía:"
                              rules={[
                                { required: true, message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED }
                              ]}>
                              <Select
                                optionFilterProp="children"
                                placeholder="Selecciona"
                                allowClear
                                fieldNames={{
                                  value: 'idMunicipio',
                                  label: 'nombreMunicipio'
                                }}
                                options={municipiosB}
                                filterOption={(inputValue, option) =>
                                  option.nombreMunicipio
                                    ?.toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                                }
                                showSearch
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                  </>
                );
              }
              if (listaAtributos.includes(findAtributoByName('calle'))) {
                atributosInputs.push(
                  <>
                    {' '}
                    <Col span={1} />
                    <Col span={4}>
                      <Form.Item
                        name="calle"
                        label="Calle:"
                        rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </>
                );
              }
              if (listaAtributos.includes(findAtributoByName('numero'))) {
                atributosInputs.push(
                  <>
                    <Col span={1}>&nbsp;</Col>
                    <Col span={3}>
                      <Form.Item
                        name="numeroExterior"
                        label="Numero exterior:"
                        rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </>
                );
              }
              if (listaAtributos.includes(findAtributoByName('colonia'))) {
                atributosInputs.push(
                  <>
                    {' '}
                    <Col span={1}>&nbsp;</Col>
                    <Col span={4}>
                      <Form.Item
                        name="colonia"
                        label="Colonia:"
                        rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                        <Input />
                      </Form.Item>
                    </Col>
                  </>
                );
              }
              return atributosInputs;
            }}
          </Form.Item>
        </Row>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) => {
            return prevValues.hallazgo !== curValues.hallazgo;
          }}>
          {() => {
            const listaAtributos =
              tipoHallazgos
                .find(
                  (tipo) =>
                    tipo.idHallazgo ===
                    (form.getFieldsValue()?.hallazgo
                      ? form.getFieldsValue()?.hallazgo
                      : idTipoHallazgo)
                )
                ?.atributos?.split(',') || [];

            const atributosInputs = [];
            atributosInputs.push(
              <Row gutter={20}>
                {listaAtributos.includes(findAtributoByName('codigoPostal')) && (
                  <Col span={2}>
                    <Form.Item
                      name="cp"
                      label="CP:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <SimpleNumericInput />
                    </Form.Item>
                  </Col>
                )}
                {listaAtributos.includes(findAtributoByName('entreCalle1')) && (
                  <Col span={4}>
                    <Form.Item name="entrecallesP" label="Entre calle:">
                      <Input />
                    </Form.Item>
                  </Col>
                )}
                {listaAtributos.includes(findAtributoByName('entreCalle2')) && (
                  <Col span={4}>
                    <Form.Item name="entrecallesS" label="y calle:">
                      <Input />
                    </Form.Item>
                  </Col>
                )}
                {listaAtributos.includes(findAtributoByName('referencias')) && (
                  <Col span={5}>
                    <Form.Item
                      name="referencias"
                      label="Referencias del lugar:"
                      rules={[{ required: true, message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED }]}>
                      <Input />
                    </Form.Item>
                  </Col>
                )}
                <Col span={4}>
                  <div>
                    <IconUbicacion className="ubicacion-visita-icon" />
                  </div>
                  <div className="ubicacion-visita-icon-text">
                    <Button type="link"> Selecciona la ubicacion en el mapa </Button>
                  </div>
                </Col>
              </Row>
            );

            return atributosInputs;
          }}
        </Form.Item>

        <Row gutter={20}>
          <Col span={5}>
            <Form.Item name="latitud" label="Latitud:">
              <Input placeholder="Escribe..." readOnly />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item name="longitud" label="Longitud:">
              <Input placeholder="Escribe..." readOnly />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={24}>{searchValueMapa === 'asda' ? setMapUbicacion() : setMapUbicacion()}</Col>
        </Row>
      </Form>
    </div>
  );
};

Ubicacion.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    validateFields: PropTypes.func
  }).isRequired,
  idTipoHallazgo: PropTypes.number.isRequired,
  latitud: PropTypes.number.isRequired,
  longitud: PropTypes.number.isRequired
};

export default Ubicacion;
